import { t } from "react-multi-lang";
import MyDialog from "../../../components/Dialog/dialog"




interface iProps{open:boolean,setOpen:Function,data:any}
const SuppliersDetails =({open,setOpen,data}:iProps)=>{


return (
    <MyDialog open={open} setOpen={setOpen}
    title={t("supplier_details")}>
        {data}
    </MyDialog>
)

}
export default SuppliersDetails;